import React from 'react';
import { mergeSvgPath } from './utils';
import { useRatioContext } from 'src/hook/useChangeRatio';

const SvgMerge = ({
  backgroundImage,
  shapeData,
  outline,
  handleClick,
  hiddenIndex,
  onDragEnd,
  allowClickSvG = false,
  removeItem,
  onRotateEnd,
  extraState,
  isDeleteMode,
  isRestoreMode,
  isSingleShowMode,
  shapeSizeData,
  onDragDeleteEnd,
  onChangeCursorPosition,
  cursorSize,
  whiteBackground,
  isEndPhase,
}: any) => {
  const {stateRatio} = useRatioContext()
  return (
    <>
      {mergeSvgPath({
        backgroundImage,
        shapeData,
        outline,
        handleClick,
        hiddenIndex,
        onDragEnd,
        allowClickSvG,
        removeItem,
        onRotateEnd,
        extraState,
        isDeleteMode,
        isRestoreMode,
        isSingleShowMode,
        shapeSizeData,
        onDragDeleteEnd,
        onChangeCursorPosition,
        cursorSize,
        whiteBackground,
        isEndPhase,
        stateRatio
      })}
    </>
  );
};

export default SvgMerge;
